import { tVProgramErrorRaised } from '@kinopoisk-int/evgen-web-events/web/tv_program';

import { useEventCallback } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback';

import { buildChannelProgramModalErrorParams } from '../builders/channelProgramModalErrorParamsBuilder';

interface Options {
    channelId: string;
    channelName?: string;
}
export function useChannelProgramErrorRaised(uiParams: Options) {
    const handleShowed = useEventCallback({
        event: tVProgramErrorRaised,
        eventParamsBuilder: buildChannelProgramModalErrorParams,
        uiParams,
    });

    return handleShowed;
}
